import { render, staticRenderFns } from "./NoVideo.vue?vue&type=template&id=f63fd81c&"
import script from "./NoVideo.vue?vue&type=script&lang=js&"
export * from "./NoVideo.vue?vue&type=script&lang=js&"
import style0 from "./NoVideo.vue?vue&type=style&index=0&id=f63fd81c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports